import { AnyAction } from "redux";
import { QUERY_POSTCODE, SAVE_TENANCIES, SAVE_ASSOCIATED_ASSETS, SAVE_CUSTOMER_ID, APP_CONFIG_VALUE,
  SAVE_ASSET_ADDRESS, SAVE_DEFAULT_ADDRESS, SAVE_SELECTED_TENANCICY, CUSTOMER_DETAILS, WORK_ORDER_REPAIR,
  SAVE_CUSTOMERS_PHONE_NUMBERS, SAVE_CUSTOMERID, SAVE_CONTRACTOR_NAME, SAVE_MAINTRESP, SAVE_REPRESP,
  SAVE_HEATINGCASE, SAVE_DETERMINED_CONTRCACTOR_DETAILS, SAVE_CONTRCACTOR_PAYLOAD, SAVE_AVAILABILITY_RESPONSE,
  SESSION_TIME_OUT_MESSAGE, SAVE_REFERENCE_NUMBER,
  SAVE_TENANCY_SUMMARY_LIST , ASSET_DATA,SAVE_CONTRCACTOR_INTEGERATED,REPAIR_HISTORY_DATA,
  SAVE_EXTERNAL_WORKORDER_CONTRACTORS,
  SAVE_AVAILABILITY_METADATA_RESPONSE,SAVE_ELIGIBLE_FOR_ENHANCEDDIAGNOSTICS,SAVE_ASSET_ELIGIBILITY_DETAILS, SAVE_SUBSESSION_ASSETS_ELIGIBILITY_DETAILS, RESET_ADDRESS, 
  DMC_WORK_ORDER_REPAIR,
  SAVE_DMC_DETERMINED_CONTRCACTOR_DETAILS} from "../actionTypes";

const initialState = {
  assetData: undefined,
  addresses: [],
  customertenancies: [],
  customerassociatedassets: [],
  tenancysummarylist: [],
  customerid: "",
  toggleValue: undefined,
  defaultaddresss: undefined,
  assetAddress: undefined,
  selectedTenancy: undefined,
  workOrderRepair: undefined,
  saveCustomerDetails: undefined,
  customerPhoneNumber: [],
  contractorname: "",
  referenceno: "",
  determinedcontractordetails: undefined,
  getContractorPayload: undefined,
  getIntegeratedContractor: undefined,
  repairHistoryData: undefined,
  maintresp: undefined,
  repairresp: undefined,
  heatinghotwatercase: undefined,
  contractorAvailabilityResponse: undefined,
  showSessionTimeOutMessage: false,
  externalWorkOrderContractors: [],
  contractorAvailabilityMetaDataResponse: undefined,
  isEligibleForEnhancedDiagnostics: false,
  isRepairEligible: false,
  currentAssetEligibilityDetails: undefined,
  subSessionAssetsEligibilityDetails: [],
  dmcWorkOrderRepair:undefined
};

const addressReducer = (state: any = initialState, action: AnyAction): any => {
  switch (action.type) {
    case RESET_ADDRESS:
      return initialState;
    case ASSET_DATA: {
      return {
        assetData: action.payload,
      };
    }
    case QUERY_POSTCODE: {
      return {
        addresses: action.payload,
      };
    }
    case SAVE_TENANCIES: {
      return {
        ...state,
        customertenancies: action.payload,
      };
    }
    case SAVE_ASSOCIATED_ASSETS: {
      return {
        ...state,
        customerassociatedassets: action.payload,
      };
    }   
    case SAVE_TENANCY_SUMMARY_LIST: {
      return {
        ...state,
        tenancysummarylist: action.payload,
      };
    } 
    case SAVE_CUSTOMER_ID: {
      return {
        ...state,
        customerid: action.payload,
      };
    }
    case APP_CONFIG_VALUE: {
      return {
        ...state,
        toggleValue: action.payload,
      };
    }
    // case APP_CONFIG_COVID_VALUE: {
    //   return {
    //     ...state,
    //     covidtoggleValue: action.payload,
    //   };
    // }
    
    case SAVE_DEFAULT_ADDRESS: {
      return {
        ...state,
        defaultaddresss: action.payload,
      };
    }
    case SAVE_ASSET_ADDRESS: {
      return {
        ...state,
        assetAddress: action.payload,
      };
    }
    case SAVE_SELECTED_TENANCICY: {
      return {
        ...state,
        selectedTenancy: action.payload,
      };
    }
    case WORK_ORDER_REPAIR: {
      return {
        ...state,
        workOrderRepair: action.payload,
      };
    }
    case CUSTOMER_DETAILS: {
      return {
        ...state,
        saveCustomerDetails: action.payload,
      };
    }
    case SAVE_CUSTOMERS_PHONE_NUMBERS: {
      return {
        ...state,
        customerPhoneNumber: action.payload,
      };
    }
    case SAVE_CUSTOMERID: {
      return {
        ...state,
        customerid: action.payload,
      };
    }
    case SAVE_CONTRACTOR_NAME: {
      return {
        ...state,
        contractorname: action.payload,
      };
    }
    case SAVE_REFERENCE_NUMBER: {
      return {
        ...state,
        referenceno: action.payload,
      };
    }
    case SAVE_DETERMINED_CONTRCACTOR_DETAILS: {
      return {
        ...state,
        determinedcontractordetails: action.payload,
      };
    }
    case SAVE_DMC_DETERMINED_CONTRCACTOR_DETAILS: {
      return {
        ...state,
        dmcDeterminedcontractordetails: action.payload,
      };
    }
    
    case SAVE_CONTRCACTOR_PAYLOAD: {
      return {
        ...state,
        getContractorPayload: action.payload,
      };
    }
    case SAVE_CONTRCACTOR_INTEGERATED: {
      return {
        ...state,
        getIntegeratedContractor: action.payload,
      };
    }
    case REPAIR_HISTORY_DATA: {
      return {
        ...state,
        repairHistoryData: action.payload,
      };
    }
    case SAVE_MAINTRESP: {
      return {
        ...state,
        maintresp: action.payload,
      };
    }
    case SAVE_REPRESP: {
      return {
        ...state,
        repairresp: action.payload,
      };
    }
    case SAVE_HEATINGCASE: {
      return {
        ...state,
        heatinghotwatercase: action.payload,
      };
    }
    case SAVE_AVAILABILITY_RESPONSE: {
      return {
        ...state,
        contractorAvailabilityResponse: action.payload,
      };
    }
    case SESSION_TIME_OUT_MESSAGE: {
      return {
        ...state,
        showSessionTimeOutMessage: action.payload,
      };
    }
    case SAVE_EXTERNAL_WORKORDER_CONTRACTORS: {
      return {
        ...state,
        externalWorkOrderContractors: action.payload,
      };
    } 
    case SAVE_AVAILABILITY_METADATA_RESPONSE: {
      return {
        ...state,
        contractorAvailabilityMetaDataResponse: action.payload,
      };
    } 
    case SAVE_ELIGIBLE_FOR_ENHANCEDDIAGNOSTICS: {
      return {
        ...state,
        isEligibleForEnhancedDiagnostics: action.payload,
      };
    } 
    case SAVE_ASSET_ELIGIBILITY_DETAILS: {
      return {
        ...state,
        currentAssetEligibilityDetails: action.payload,
      };
    } 
    case SAVE_SUBSESSION_ASSETS_ELIGIBILITY_DETAILS: {
      return {
        ...state,
        subSessionAssetsEligibilityDetails: action.payload,
      };
    } 
    case DMC_WORK_ORDER_REPAIR: {
      return {
        ...state,
        dmcWorkOrderRepair: action.payload,
      };
    }
    default:
      return state;
  }
};
export default addressReducer;
